const getIsUserPaypalSubscriptionCancelled = (userPaypalSubscription) => (userPaypalSubscription.status === 'CANCELLED');

export { getIsUserPaypalSubscriptionCancelled };
